import { eShablonItemType, eShablonValueType } from '@/models/enums';
import isNil from 'lodash/isNil';

export class ShablonJsonValueItem {
  code: string | null = null;
  type: eShablonItemType = eShablonItemType.NotSpecified;
  subtype: eShablonValueType = eShablonValueType.NotSpecified;
  value: string | null = null;
  dictId: number = 0;
  dictCode: string | null = null;
  dictName: string | null = null;
  dictEntryId: number = 0;
  dictEntryCode: string | null = null;
  dictEntryName: string | null = null;
}

export class ShablonJsonValueTableRow {
  index: number = 0;
  fields: Array<ShablonJsonValueItem> = [];
  tables: Array<ShablonJsonValueTable> = [];
}

export class ShablonJsonValueTable {
  code: string = '';
  rows: Array<ShablonJsonValueTableRow> = [];
}

export class ShablonJsonValuesFormData {
  fields: ShablonJsonValueItem[] = [];
  tables: ShablonJsonValueTable[] = [];
}

export class ShablonJsonValuesRoot {
  version: number = 1;
  formData: ShablonJsonValuesFormData = new ShablonJsonValuesFormData();
}

export class ShablonConfigDocument {
  documentCode?: string;
  documentCreatedDate?: string;
  documentName?: string;
  documentDate?: string;
  documentNumber?: string;
  valuesJson?: string;
}

export class ShablonConfigFile {
  Id: number;
  FileTypeCode: string;
  FileTypeNameUk: string;
  FileTypeNameEn: string;
  RowNumber: number = -1;
  ColNumber: number = -1;
  Required: boolean;

  constructor(dto?: any) {
    this.Id = dto?.Id || 0;
    this.FileTypeCode = dto?.FileTypeCode || '';
    this.FileTypeNameUk = dto?.FileTypeNameUk || '';
    this.FileTypeNameEn = dto?.FileTypeNameEn || '';
    this.RowNumber = dto?.RowNumber || 0;
    this.ColNumber = dto?.ColNumber || 0;
    this.Required = dto?.Required || false;
  }
}

export class ShablonConfigItem {
  Id: string;
  TableId: string;
  TableCellId: number;
  Type: eShablonItemType;
  ValueType: eShablonValueType;
  DictCode: string;
  DictGroup: string;
  DictFieldCode: string;
  DictFieldName: string;
  DictFieldValueHasSpacesToFill: boolean;
  DictFieldValueFillingItemId: string;
  NameUk: string;
  NameEn: string;
  DescUk: string;
  DescEn: string;
  PageNumber: number;
  RowNumber: number;
  ColNumber: number;
  AutoFill: boolean;
  ShablonAutoFieldCode: string;
  Required: boolean;
  MaxLength: number;
  MinValue: string;
  MaxValue: string;
  VisibilityFieldId: string;
  VisibilityFieldValue: boolean;

  constructor(dto?: any) {
    this.Id = dto?.Id || null;
    this.TableId = isNil(dto?.TableId) ? '-1' : dto.TableId;
    this.TableCellId = isNil(dto?.TableCellId) ? -1 : dto.TableCellId;
    this.Type = dto?.Type || eShablonItemType.Field;
    this.ValueType = dto?.ValueType || eShablonValueType.String;
    this.DictCode = dto?.DictCode || '';
    this.DictGroup = dto?.DictGroup || '';
    this.DictFieldCode = dto?.DictFieldCode || '';
    this.DictFieldName = dto?.DictFieldName || null;
    this.DictFieldValueHasSpacesToFill = dto?.DictFieldValueHasSpacesToFill || false;
    this.DictFieldValueFillingItemId = dto?.DictFieldValueFillingItemId || '';
    this.NameUk = dto?.NameUk || '';
    this.NameEn = dto?.NameEn || '';
    this.DescUk = dto?.DescUk || null;
    this.DescEn = dto?.DescEn || null;
    this.PageNumber = dto?.PageNumber || 0;
    this.RowNumber = dto?.RowNumber || 0;
    this.ColNumber = dto?.ColNumber || 0;
    this.AutoFill = dto?.AutoFill || false;
    this.ShablonAutoFieldCode = dto?.ShablonAutoFieldCode || null;
    this.Required = dto?.Required || false;
    this.MaxLength = isNil(dto?.MaxLength) ? 0 : dto.MaxLength;
    this.MinValue = isNil(dto?.MinValue) ? '' : dto.MinValue;
    this.MaxValue = isNil(dto?.MaxValue) ? '' : dto.MaxValue;
    this.VisibilityFieldId = dto?.VisibilityFieldId || null;
    this.VisibilityFieldValue = dto?.VisibilityFieldValue || false;
  }
}

export class ShablonConfigTable {
  Id: string;
  TableId: string;
  TableCellId: number;
  CellCounts: number;
  ItemCounts: number;
  NameUk: string;
  NameEn: string;
  DescrUk: string;
  DescEn: string;
  UseAsTable: boolean;
  RowNumber: number;
  ColNumber: number;
  VisibilityFieldId: string;
  VisibilityFieldValue: boolean;
  ShowTableCaption: boolean;
  MaxRowNumber: Number;

  constructor(dto?: any) {
    this.Id = dto?.Id || '0';
    this.TableId = isNil(dto?.TableId) ? '-1' : dto.TableId;
    this.TableCellId = isNil(dto?.TableCellId) ? -1 : dto.TableCellId;
    this.CellCounts = isNil(dto?.CellCounts) ? -1 : dto.CellCounts;
    this.ItemCounts = dto?.ItemCounts || 0;
    this.NameUk = dto?.NameUk || '';
    this.NameEn = dto?.NameEn || '';
    this.DescrUk = dto?.DescrUk || null;
    this.DescEn = dto?.DescEn || null;
    this.UseAsTable = dto?.UseAsTable || false;
    this.RowNumber = dto?.RowNumber || 0;
    this.ColNumber = dto?.ColNumber || 0;
    this.VisibilityFieldId = dto?.VisibilityFieldId || null;
    this.VisibilityFieldValue = dto?.VisibilityFieldValue || false;
    this.ShowTableCaption = isNil(dto?.ShowTableCaption) ? true : dto.ShowTableCaption;
    this.MaxRowNumber = isNil(dto?.MaxRowNumber) ? -1 : +dto.MaxRowNumber;
  }
}

export class ShablonConfig {
  Varsin: number;
  CreateDataJson: boolean;
  Tables: ShablonConfigTable[];
  Items: ShablonConfigItem[];
  Files: ShablonConfigFile[];

  constructor(dto?: any) {
    this.Varsin = dto?.Varsin || 2;
    this.CreateDataJson = dto?.CreateDataJson || false;
    this.Tables = (dto?.Tables || []).map(t => new ShablonConfigTable(t));
    this.Items = (dto?.Items || []).map(i => new ShablonConfigItem(i));
    this.Files = (dto?.Files || []).map(f => new ShablonConfigFile(f));
  }
}

export class ShablonValues {
  Items: ShablonValueField[] = [];
  Tables: ShablonValueTable[] = [];
  Files: ShablonValueFile[] = [];
}

export class ShablonValueField {
  Id: string | null = null;
  Value: string | null = null;
  ValueType: number = 0;
  DictEntryId: number = 0;
  Table: ShablonValueTable | null = null;
}

export class ShablonValueTableRow {
  RowId: string | null = null;
  Cells: ShablonValueField[] = [];
}

export class ShablonValueTable {
  Id: string = '-1';
  Rows: ShablonValueTableRow[] = [];
}

export class ShablonValueFile {
  Id: number = 0;
  FileTypeCode: string | null = null;
  FileName: string | null = null;
  Content: string | null = null;
}

export enum ShablonDocumentOrgFilter {
  All = 0,
  NotOrganisational = 1,
  Organisational = 2
}
